// extracted by mini-css-extract-plugin
export var legendIndicator = "_bq-1";
export var legendRight = "_bq-0";